export { default } from './svg/arrow-fill-left.svg';
